<template>
  <div class="main-container">
    <div v-if="!loading" class="server-info__wrapper">
      <!-- show details for selected server  -->
      <admin-server-info
        v-if="selectedServer"
        :server-info="selectedServer"
        @updateServerInfoFlag="$emit('updateServerInfoFlag', $event)"
      />

      <!-- show common data for all servers -->
      <admin-common-info
        v-else
        :servers="servers"
        @serverSelected="$emit('serverSelected', { server: $event.server })"
      />
    </div>

    <!-- Loader -->
    <div v-else class="loader-container">
      <circle2
        color="var(--main-bg-color)"
        background="#c4c4c4"
        stroke="4px"
        size="60px"
      ></circle2>
    </div>
  </div>
</template>

<script>
import AdminServerInfo from "@/components/admin/main/server/AdminServerInfo.vue";
import AdminCommonInfo from "@/components/admin/main/common/AdminCommonInfo.vue";

import { Circle2 } from "vue-loading-spinner";

// @group Admin Page
// Admin page main panel
export default {
  name: "AdminMainPanel",
  components: {
    AdminServerInfo,
    AdminCommonInfo,
    Circle2
  },
  props: {
    // selected server information
    selectedServer: {
      type: Object,
      default: null
    },
    // servers information
    servers: {
      type: Array,
      default: () => []
    },
    // is panel in loading state
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.main-container {
  height: 100%;
  background-color: var(--main-bg-color);
}
.server-info__wrapper {
  padding: 1.5em 2em;
}
.loader-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
